import { render, staticRenderFns } from "./GiveawayNoPointsView.vue?vue&type=template&id=d3af4f62"
import script from "./GiveawayNoPointsView.vue?vue&type=script&lang=js"
export * from "./GiveawayNoPointsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports